export function AppLoadingScreen() {
  return <div className="min-h-screen bg-muted" aria-busy="true" />;
}
